module.exports = "/_next/static/images/send-abcfa226679649c2f75d934be03368ad.svg";